function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import BaseProvider from "./BaseProvider";
import isFunction from "lodash/isFunction";
// TODO: inform about Meta information, like: useIconFont or not ...
var CBookProvider = /*#__PURE__*/ function(BaseProvider) {
    "use strict";
    _inherits(CBookProvider, BaseProvider);
    var _super = _createSuper(CBookProvider);
    function CBookProvider() {
        _classCallCheck(this, CBookProvider);
        var _this;
        _this = _super.apply(this, arguments);
        // Set a Getter Function to return Data
        _defineProperty(_assertThisInitialized(_this), "setDataGetter", function(getDataFunc) {
            _this._getMeta = !!getDataFunc && isFunction(getDataFunc) ? getDataFunc : _this._getMeta;
        });
        // Fanout Data to all Subscriptions
        _defineProperty(_assertThisInitialized(_this), "dispatch", function() {
            _this.fanout("cbook", "meta", _this._getMeta());
        });
        _defineProperty(_assertThisInitialized(_this), "_getMeta", function() {
            // These are the Default return values
            console.warn("No Data Getter Set. Returning Default Values. Set a Getter with CBookProvider.setDataGetter(Function)");
            return {
                name: "",
                storyMode: false,
                language: "",
                theme: "light",
                useIconFontFallback: false
            };
        });
        _defineProperty(_assertThisInitialized(_this), "DataStruct", function(cbook, state, isPreview) {
            var lang = "de";
            if (cbook) {
                lang = cbook.default_ui_language || cbook.default_frontend_language;
            }
            return {
                name: cbook ? cbook.name : "",
                storyMode: state && !!state.isStoryModeActive,
                language: lang,
                theme: cbook ? cbook.theme : "light",
                useIconFontFallback: cbook ? cbook.use_icon_font_images : false,
                isPreviewMode: !!isPreview,
                student_id: cbook ? cbook.student_id : "",
                student_name: cbook ? cbook.student_name : ""
            };
        });
        return _this;
    }
    _createClass(CBookProvider, [
        {
            // When there is a new listener subscribed
            key: "onSubscribed",
            value: function onSubscribed(uid, channel) {
                // Initialization Message
                this.publish(uid, "cbook", "meta", this._getMeta());
            }
        },
        {
            // When an extension sends data
            key: "onMessageReceived",
            value: function onMessageReceived(uid, channel, msgId, data) {
            // An Extension can not send anything meaningful to the cBook Provider
            //  -> Readonly.
            }
        }
    ]);
    return CBookProvider;
}(BaseProvider);
CBookProvider.providedChannels = [
    "cbook"
];
var _CBookProvider = new CBookProvider();
export default _CBookProvider;
